import i18next from 'i18next'
import de from './translations/de.json'
import en from './translations/en.json'
import fr from './translations/fr.json'
import it from './translations/it.json'
import { languages } from '../types/constants'

const defaultLang = 'de'
const browserLang = navigator.language.slice(0, 2).toLowerCase()
const initialLang = languages.includes(browserLang) ? browserLang : defaultLang

export const initTranslations = () =>
  i18next.init({
    interpolation: { escapeValue: false },
    lng: initialLang,
    resources: {
      en: {
        translation: en,
      },
      de: {
        translation: de,
      },
      fr: {
        translation: fr,
      },
      it: {
        translation: it,
      },
    },
  })
